import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Cart = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    padding: 20px;
  }

  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    && .btn_cart {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`;

export const Title = styled.div`
  font-size: 32px;
  line-height: 1.375em;
  font-weight: 600;
  margin-bottom: 27px;
  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    font-size: 24px;
    margin-bottom: 9px;
  }
`;

export const CartContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 767px) {
    .animated {
      min-height: calc(100 * var(--full-vh) - 186px);
    }
  }
`;

export const Panel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;

  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    .btn {
      width: auto;
      height: 52px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
  }

  @media (max-width: 500px) {
    .btn {
      width: auto;
      padding: 8px 10px;
    }

    .btn_cart span {
      display: block;
      max-width: 100px;
      overflow: hidden;
    }
  }
`;

export const AmountContainer = styled.div`
  width: 200px;

  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    width: auto;
    text-align: right;
    top: 3px;
    position: relative;
  }
`;

export const Amount = styled.div``;

export const Total = styled.div`
  display: flex;
  font-size: 24px;
  line-height: 1em;
  color: var(--carbone100);
  font-weight: 700;

  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    font-size: 18px;
  }
`;

export const Value = styled.div`
  padding: 0 7px;
`;

export const CartRow = styled.div`
  border-bottom: 1px solid var(--aluminium35);
`;

export const OrderBtn = styled(Link)`
  border: none;
  padding: 15px 20px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  margin-right: 8px;
  color: var(--white);
  background: var(--theme-palette-brand-bg);
  transition: var(--transition);

  &:hover {
    color: var(--white);
    background: var(--theme-palette-brand-bg-hover);
  }
`;
